import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import useInfiniteDataQuery from '../../../hooks/useInfiniteDataQuery/useInfiniteDataQuery';
import { InfiniteDataQueryFnUtils } from '../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { OmitPaginatedEndpointParams } from '../../types';
import {
  getFindCollectionsListKey,
  getFindOrderCollectionsListKey,
  getInfiniteCollectionsListKey,
} from './collections.keys';
import { findCollectionsList, findOrderCollectionsList } from './collections.repository';
import {
  FindCollectionsListOutput,
  FindCollectionsListParams,
  FindOrderCollectionsListOutput,
  FindOrderCollectionsListParams,
} from './collections.types';

export const useFindOrderCollectionsList = (
  params: FindOrderCollectionsListParams,
  options?: UseDataQueryOptions,
) =>
  useDataQuery<FindOrderCollectionsListOutput | null>(
    {
      queryKey: getFindOrderCollectionsListKey(params),
      queryFn: async () => {
        const data = await findOrderCollectionsList({ 'order[name]': 'ASC', ...params });
        if (!data.ok || !data.data) {
          return null;
        }
        return data.data;
      },
    },
    options,
  );

export const useFindCollectionsList = (
  params: FindCollectionsListParams,
  options?: UseDataQueryOptions,
) =>
  useDataQuery<FindCollectionsListOutput | null>(
    {
      queryKey: getFindCollectionsListKey(params),
      queryFn: async () => {
        const data = await findCollectionsList({ 'order[name]': 'ASC', ...params });
        if (!data.ok || !data.data) {
          return null;
        }
        return data.data;
      },
    },
    options,
  );

export const useInfiniteCollectionsList = (
  params: OmitPaginatedEndpointParams<FindCollectionsListParams>,
) =>
  useInfiniteDataQuery({
    limit: 20,
    queryKey: getInfiniteCollectionsListKey(params),
    defaultOrderBy: { name: 'ASC' },
    queryFn: InfiniteDataQueryFnUtils.fetcherWithCountAndParams(findCollectionsList, params),
  });
